import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, ConfirmEventType, ConfirmationService } from 'primeng/api';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';

@Component({
    selector: 'app-pessoa-list',
    templateUrl: './pessoa-list.component.html',
    styleUrls: ['./pessoa-list.component.scss'],
    standalone: false
})
export class PessoaListComponent implements OnInit, AfterViewInit {
  home = { icon: 'pi pi-home', routerLink: '/' };
  item: any = []
  tituloPagina: any;
  pessoas: any[] = [];
  array_funcionarios: any[] = [];
  totalRecords: number = 0
  grupo_usuario: any
  tela_funcionarios: boolean = false
  voltar_dashboard: boolean = false
  direitoEditar: boolean = false
  direitoInserir: boolean = false
  direitoExcluir: boolean = false
  filterText: string = ''
  mostrarDesativados: boolean = false

  cols_funcionarios = [
    { field: 'funcionario', header: 'Funcionario' },
    { field: 'email', header: 'E-mail' },
    { field: 'funcao', header: 'Função' },
  ]

  globalFilterFields = [
    "id",
    "nome",
    "tipo",
    "created_at",
  ]

  user = JSON.parse(localStorage.getItem('user') ?? '{}');
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(private _router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    protected _pessoaService: PessoaService,
    protected _permissaoService: PermissoesService,
  ) { }

  ngOnInit(): void {
    let url = window.location.href;
    if (url.includes('cliente-list')) {
      this.tituloPagina = 'Clientes';
      this.direitoInserir = this._permissaoService.can('clientes_inserir');
      this.direitoEditar = this._permissaoService.can('clientes_editar');
      this.direitoExcluir = this._permissaoService.can('clientes_excluir');
    } else if (url.includes('fornecedor-list')) {
      this.tituloPagina = 'Fornecedores';
      this.direitoInserir = this._permissaoService.can('fornecedores_inserir');
      this.direitoEditar = this._permissaoService.can('fornecedores_editar');
      this.direitoExcluir = this._permissaoService.can('fornecedores_excluir');
    } else if (url.includes('integrador-list')) {
      this.tituloPagina = 'Integradores';
      this.direitoInserir = this._permissaoService.can('integradores_inserir');
      this.direitoEditar = this._permissaoService.can('integradores_editar');
      this.direitoExcluir = this._permissaoService.can('integradores_excluir');
    }
    this._fetchData();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  /**
   * Normaliza string para filtro: minúsculas, sem acentos (Á = a, Ç = c).
   */
  private normalizeForFilter(str: string | number | null | undefined): string {
    if (str == null || str === undefined) return '';
    const s = String(str).toLowerCase().trim();
    return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  get displayedPessoas(): any[] {
    if (!this.filterText || !this.filterText.trim()) return this.pessoas;
    const term = this.normalizeForFilter(this.filterText);
    if (!term) return this.pessoas;
    return this.pessoas.filter((p: any) => {
      return this.globalFilterFields.some(field => {
        const value = p[field];
        if (value == null && value !== 0) return false;
        const normalized = this.normalizeForFilter(
          field === 'created_at' && value ? new Date(value).toLocaleDateString('pt-BR') : value
        );
        return normalized.includes(term);
      });
    });
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperElement = this.tableWrapper.nativeElement;
      const wrapperHeight = wrapperElement.offsetHeight;
      
      // Se o wrapper ainda não tem altura, tenta novamente
      if (wrapperHeight === 0) {
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 100);
        return;
      }
      
      // Subtrai apenas altura do caption (~60px), o paginator externo está fora do wrapper
      const calculatedHeight = wrapperHeight - 60;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    } else {
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 100);
    }
  }


  sortByKey(array: any, key: any, type = 'asc') {
    return array.sort(function (a: any, b: any) {
      if (type == 'asc') {
        var x = a[key]; var y = b[key];
      } else {
        var x = b[key]; var y = a[key];
      }
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  indexLojista() {
   
  }

  onMostrarDesativadosChange(event?: { checked?: boolean }): void {
    if (event && typeof event.checked === 'boolean') {
      this.mostrarDesativados = event.checked;
    }
    this._fetchData();
  }

  _fetchData(event = null): void {
    let params: any;
    if (this.tituloPagina == 'Clientes') {
      params = { cliente: true, mostrar_desativados: !!this.mostrarDesativados };
    } else if (this.tituloPagina == 'Fornecedores') {
      params = { fornecedor: true };
    } else if (this.tituloPagina == 'Integradores') {
      params = { integrador: true };
    }

    let page;

    if (event == null) {
      page = 1;
    } else {
      page = (event.first / event.rows) + 1;
    }

    this._pessoaService.paginate(params, page).subscribe((json: any) => {
      json.data.map(item => {
        if(item.tipo == 0){
           item.tipo = 'Pessoa Física'
        } else {
          item.tipo = 'Pessoa Jurídica'
        }
      })
      this.pessoas = json.data
      this.totalRecords = json.total
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    });
  }

  link(event: any) {
    let subdominio = localStorage.getItem('subdominio')
  }

  inativar_ativar(event: any, status: any) {
  }

  indexFuncionario() {

  }

  indexCdl() {
  

  }

  openNew() {
    let url = window.location.href;
    if (url.includes('cliente-list')) {
      this._router.navigate(['/cadastro/cliente-form/null']);
    } else if (url.includes('fornecedor-list')) {
      this._router.navigate(['/cadastro/fornecedor-form/null']);
    }else if (url.includes('integrador-list')) {
      this._router.navigate(['/cadastro/integrador-form/null']);
    }
  }

  edit(event: any) {
    let url = window.location.href;
    if (url.includes('cliente-list')) {
      this._router.navigate([`/cadastro/cliente-form/${event.id}`]);
    } else if (url.includes('fornecedor-list')) {
      this._router.navigate([`/cadastro/fornecedor/${event.id}`]);
    } else if (url.includes('integrador-list')) {
      this._router.navigate([`/cadastro/integrador-form/${event.id}`]);
    }
  }

  confirmarExclusao(pessoa: any): void {
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir "${pessoa.nome}"?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => this.excluir(pessoa.id),
    });
  }

  excluir(id: number): void {
    this._pessoaService.destroy(id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Registro excluído com sucesso',
        });
        this._fetchData();
      },
      error: (err) => {
        const msg = err?.error?.message || 'Erro ao excluir registro';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      },
    });
  }

  funcionarios(event: any) {
    this.array_funcionarios = []
    this.tela_funcionarios = true

    this.array_funcionarios.push(
      {
        funcionario: 'Fulano',
        email: 'fulano@email.com',
        funcao: 'Técnico de informática',
      },
      {
        funcionario: 'Ciclano',
        email: 'ciclano@email.com',
        funcao: 'Contador',
      },
      {
        funcionario: 'Beltrano',
        email: 'beltrano@email.com',
        funcao: 'Backoffice',
      },

    )
  }
}
